"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("babel-polyfill");
var React = require("react");
var ReactDOM = require("react-dom");
var $ = require("jquery");
var bayes_server_components_1 = require("bayes-server-components");
var bayes_server_1 = require("bayes-server");
var networkContext = new bayes_server_components_1.NetworkContext();
ReactDOM.render(React.createElement(bayes_server_components_1.NetworkViewer, { networkContext: networkContext }), document.getElementById("root"));
// tslint:disable-next-line:no-any
$.get("/../network-repository/Oil Wildcatter.bayes", function (data, status) {
    var network = new bayes_server_1.Network();
    network.loadFromString(data);
    networkContext.network = network;
}, "text");
